import { useState } from 'react';

import { CurrentLoginPage } from '@/features/auth/enums';
import { Credentials } from './Credentials';
import { OTPVerification } from './OTPVerification';

export const Login = () => {
  const [currentPage, setCurrentPage] = useState<CurrentLoginPage>(CurrentLoginPage.Credentials);
  const [email, setEmail] = useState<string>('');
  return currentPage === CurrentLoginPage.Credentials ? (
    <Credentials
      onCredentialsSuccess={(email) => {
        setEmail(email);
        setCurrentPage(CurrentLoginPage.OtpVerification);
      }}
    />
  ) : (
    <OTPVerification email={email} onBack={() => setCurrentPage(CurrentLoginPage.Credentials)} />
  );
};
